import {
  FlexboxModule,
  GridModule,
  SpacingModule,
  PaddingModule,
  TabsStickyModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { SectionNavComponent } from './section-nav.component';
import { SectionAnchorComponent } from './section-anchor/section-anchor.component';

@NgModule({
  declarations: [SectionAnchorComponent, SectionNavComponent],
  imports: [
    BrSdkModule,
    CommonModule,
    FlexboxModule,
    GridModule,
    PaddingModule,
    SpacingModule,
    TabsStickyModule,
  ],
  exports: [SectionAnchorComponent, SectionNavComponent],
  entryComponents: [SectionAnchorComponent, SectionNavComponent],
})

/**
 * Section Nav Module
 */
export class SectionNavModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Section Anchor': SectionAnchorComponent,
      'Section Nav': SectionNavComponent,
    };
  }
}
